import React from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const TextEditor = ({ editorState, setEditorState }) => {
  const onEditorStateChange = (value) => {
    setEditorState({ ...editorState, description: value });
  };

  return (
    <div>
      <Editor
        editorState={editorState.description}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor text-editor-section"
        onEditorStateChange={onEditorStateChange}
        placeholder={"Description"}

        // toolbar={{
        //   image: { className: "hidden" },
        // }}
      />
    </div>
  );
};

export default TextEditor;
